import React, { useEffect } from 'react';
import first_foto from '../static/pictures/Home_pictures/first.jpg'
import second_foto from '../static/pictures/Home_pictures/second.jpg'
import third_foto from '../static/pictures/Home_pictures/third.jpg'
import { Link } from 'react-router-dom';
//import "../static/css/Home.css"

function Home() {

    useEffect(() => {
        const acc = document.getElementsByClassName("accordion");

        const handleClick = function () {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
              panel.style.maxHeight = null;
            } else {
              panel.style.maxHeight = panel.scrollHeight + "px";
            }
        };

        for (let i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", handleClick);
        }

        // Clean up listeners when component unmounts
        return () => {
            for (let i = 0; i < acc.length; i++) {
                acc[i].removeEventListener("click", handleClick);
            }
        };
    }, []);

    if (window.innerWidth < 600) {
        return (
        <div className='home_body'>
            <div className='main_section'>
                <img src={first_foto} alt='first' className='home_first_foto' />
                <div>
                    <h2>Ганна Лівшиць</h2>
                    <p>Як терапевт і супервізор ясна, структурна, підтримуюча, чутлива, надихаюча і творча.  Працюю глибоко, бережно, і з задоволенням 😉.</p>
                    <Link to='/contact' className='contact'>
                        <button>Зареєструватись</button>
                    </Link>
                </div>
            </div>





            <div className='my_work_is_section'>
                <img src={third_foto} alt='third' className='home_third_foto' />
                <div>
                        <h2>Мої послуги</h2>
                        <button className="accordion">Труднощі у сімейних та партнерських відносинах:</button>
                        <div className="panel">
                            <p>
    Порушення взаємовідносин із партнером, а також з іншими дорослими членами сім'ї (труднощі комунікацій, сімейні кризи, проблеми, непорозуміння, конфлікти у парних відносинах);
    дитячо-батьківські відносини (труднощі комунікації, виникнення агресії, примхи, непослуху; ревнощі, проблеми із прийняттям нового члена сім'ї; проблеми з самооцінкою, психологічна підтримка у стресових життєвих ситуаціях).<br/>
    відносини з нянями, бабусями та іншими важливими для дитини дорослими.
    🧷Особистісні та професійні кризи<br/></p>
                        </div>
                        <button className="accordion">📍кризи ідентичності:</button>
                        <div className="panel">
                            <p>
    кризи вікові, професійні, екзистенційні: як і куди рухатись далі, хто Я,  пошук сенсів;<br/>
    професійне вигорання, труднощі та складності на роботі; <br/>
    труднощі та емоційне вигорання у батьківстві;<br/>
    складнощі адаптації <br/></p>
                        </div>
                        <p>
    🧷Психологічні травми (дитячі травми, травми пов'язані з порушенням безпеки<br/>
    та/або особистих меж, загрозою життю, травми різних видів насилля):<br/>
    🧷Переживання горя, втрати (втрата близької людини, переїзд,<br/>
    розлучення).<br/>
    🧷Психосоматичні порушення:<br/>
    емоційна нестабільність (безсоння, спалахи гніву, апатія);<br/>
    депресивні стани;<br/>
    тривожні стани різного походження (панічні атаки, іпохондрії, обсесивно-компульсивний розлад);<br/>
    синдром роздратованого кишечника;<br/>
    психогенне безпліддя (проблеми із зачаттям, проблеми з виношуванням вагітності, втратою, безпліддя неясного генезу).<br/><br/>
    <i>ВАЖЛИВО: не працюю з маленькими дітьми ( працюю лише з батьками), не працюю з хімічно залежними ( працюю лише з їх родичами ).</i></p>
                    </div>
            </div>





            <div className='about_section'>
                <img src={second_foto} alt='second' className='home_second_foto' />
                <div>
                    <h2>Про мене</h2>
                    <p>Народилась, живу, працюю в місті Києві.
Люблю життя, людей, дуже люблю воду і природу, обожнюю плавати, трохи займаюся спортом в задоволення, є сертифікованим дайвером ( риби і глибини гарне відновлення та можливість побути з собою), маю дачу, про яку мріяла все життя. </p>
                </div>
            </div>

            <div className='FAQ'>
                <button className="accordion">З якого віку можна записатися на терапію?</button>
                <div className="panel">
                    <p>З 18-ти років</p>
                </div>

                <button className="accordion">Чи можна ходити на терапію разом з дружиною, другом чи дітьми?</button>
                <div className="panel">
                    <p>НІІІІІІІІІІІІ</p>
                </div>
            </div>
        </div>
        )}
    else {
        return (
            <div className='home_body'>
                <div className='main_section'>
                    <img src={first_foto} alt='first' className='home_first_foto' />
                    <div>
                        <h2>Ганна Лівшиць</h2>
                        <p>Як терапевт і супервізор ясна, структурна, підтримуюча, чутлива, надихаюча і творча.  Працюю глибоко, бережно, і з задоволенням 😉.</p>
                        <Link to='/contact' className='contact'>
                            <button>Зареєструватись</button>
                        </Link>
                    </div>
                </div>

                <div className='my_work_is_section'>
                    <div>
                        <h2>Мої послуги</h2>
                        <button className="accordion">Труднощі у сімейних та партнерських відносинах:</button>
                        <div className="panel">
                            <p>
    Порушення взаємовідносин із партнером, а також з іншими дорослими членами сім'ї (труднощі комунікацій, сімейні кризи, проблеми, непорозуміння, конфлікти у парних відносинах);
    дитячо-батьківські відносини (труднощі комунікації, виникнення агресії, примхи, непослуху; ревнощі, проблеми із прийняттям нового члена сім'ї; проблеми з самооцінкою, психологічна підтримка у стресових життєвих ситуаціях).<br/>
    відносини з нянями, бабусями та іншими важливими для дитини дорослими.
    🧷Особистісні та професійні кризи<br/></p>
                        </div>
                        <button className="accordion">📍кризи ідентичності:</button>
                        <div className="panel">
                            <p>
    кризи вікові, професійні, екзистенційні: як і куди рухатись далі, хто Я,  пошук сенсів;<br/>
    професійне вигорання, труднощі та складності на роботі; <br/>
    труднощі та емоційне вигорання у батьківстві;<br/>
    складнощі адаптації <br/></p>
                        </div>
                        <p>
    🧷Психологічні травми (дитячі травми, травми пов'язані з порушенням безпеки<br/>
    та/або особистих меж, загрозою життю, травми різних видів насилля):<br/>
    🧷Переживання горя, втрати (втрата близької людини, переїзд,<br/>
    розлучення).<br/>
    🧷Психосоматичні порушення:<br/>
    емоційна нестабільність (безсоння, спалахи гніву, апатія);<br/>
    депресивні стани;<br/>
    тривожні стани різного походження (панічні атаки, іпохондрії, обсесивно-компульсивний розлад);<br/>
    синдром роздратованого кишечника;<br/>
    психогенне безпліддя (проблеми із зачаттям, проблеми з виношуванням вагітності, втратою, безпліддя неясного генезу).<br/><br/>
    <i>ВАЖЛИВО: не працюю з маленькими дітьми ( працюю лише з батьками), не працюю з хімічно залежними ( працюю лише з їх родичами ).</i></p>
                    </div>
                    <img src={third_foto} alt='third' className='home_third_foto' />
                </div>

                <div className='about_section'>
                    <img src={second_foto} alt='second' className='home_second_foto' />
                    <div>
                        <h2>Про мене</h2>
                        <p>Народилась, живу, працюю в місті Києві.
    Люблю життя, людей, дуже люблю воду і природу, обожнюю плавати, трохи займаюся спортом в задоволення, є сертифікованим дайвером ( риби і глибини гарне відновлення та можливість побути з собою), маю дачу, про яку мріяла все життя. </p>
                    </div>
                </div>

                <div className='FAQ'>
                    <button className="accordion">З якого віку можна записатися на терапію?</button>
                    <div className="panel">
                        <p>З 18-ти років</p>
                    </div>

                    <button className="accordion">Чи можна ходити на терапію разом з дружиною, другом чи дітьми?</button>
                    <div className="panel">
                        <p>НІІІІІІІІІІІІ</p>
                    </div>
                </div>
            </div>
    );}
}

export default Home;
